<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <vip-level-method-table></vip-level-method-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import vipLevelMethodTable from './VIPLevelMethodTable.vue'

  export default {
    name: 'vipLevelMethod',
    components: {vipLevelMethodTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/activityLog/payment/withdraw/VIPLevelMethod.vue